import { Policy } from "../objects/policy";

// REACT_APP_API_QUOTE_SAVE=api/v1/quote/save
// REACT_APP_API_QUOTE_RATE=api/v1/quote/rate
// REACT_APP_API_QUOTE_RULES=api/v1/quote/rules/run
// REACT_APP_API_QUOTE_SERIALIZE=api/v1/quote/{quotenum}/serialize

export class LookupService {
    private coveragesApi: string;
    private zipLookupApi: string;
    
    constructor(){
        var baseApi = process.env.REACT_APP_BASE_API_URL;
        this.coveragesApi = baseApi + (process.env.REACT_APP_API_LOOKUP_COVERAGES_BY_STATE_EFFDATE ?? "");
        this.zipLookupApi = baseApi + (process.env.REACT_APP_API_LOOKUP_ZIP_CODE ?? "");
    }

    async GetCoverages(policyState:string, effectiveDate: string) {
        var effDate = new Date(effectiveDate).toLocaleDateString().replace("/", "-").replace("/", "-");
        var url = this.coveragesApi.replace("{state}", policyState).replace("{effectiveDate}", effDate);
        var response = await fetch(url,
            {
                mode: "cors",
                method: "GET",
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/json",
                    "pace-api-key": (process.env.REACT_APP_API_KEY ?? "")
                }
            });

        if(response.ok){
            return {
                ok: true,
                data: await response.json()
            }
        }else{
            return {
                ok: false,
                error:  await response.json()
            }
        }
    }

    async GetZipCode(state:string, zipCode: string) {
        
        var url = this.zipLookupApi.replace("{state}", state).replace("{zipCode}", zipCode);
        var response = await fetch(url,
            {
                mode: "cors",
                method: "GET",
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/json",
                    "pace-api-key": (process.env.REACT_APP_API_KEY ?? "")
                }
            });
            
        if(response.ok){
            return {
                ok: true,
                data: await response.json()
            }
        }else{
            switch(response.status){
                case 404:
                    return {
                        ok: false,
                        statusCode: response.status,
                        statusText: response.statusText,
                        error: "NOT FOUND"
                    }
                default:
                    return {
                        ok: false,
                        statusCode: response.status,
                        statusText: response.statusText,
                        error:  await response.json()
                    }
            }
            
        }
    }
}